import styled from "@emotion/styled";
import Tooltip from "@mui/material/Tooltip";

import { ZIndexLayer } from "shared/lib/styles";

export const StyledTooltip = styled(Tooltip)`
  z-index: ${ZIndexLayer.AppTooltip};
`;
